import { useState } from 'react';
import { Selectors, Async } from 'modules/Auth/AuthSlice';
import { useSelector, useDispatch } from 'react-redux';
import { Modal } from 'modules/Core/Common/Modal';
import { useTimezones } from 'modules/Timezones/Hooks';
import { ModalHeader } from 'modules/Core/Common/Modal/ModalHeader';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { SelectTimezone } from 'modules/Core/Common/SelectTimezone';
import { Button } from 'modules/Core/Common/Button';
import { Col, Row, FormGroup } from 'modules/Core/Common';
import i18n from 'i18next';
import * as S from './UserWithoutTimezoneModal.styles';
import { Toast } from 'modules/Core/Common';
import { defaultErrorToast } from 'modules/Utils';
import PropTypes from 'prop-types';

const TimezoneSchema = Yup.object().shape({
  timezone: Yup.string().required(),
});

const UserWithoutTimezoneForm = ({ onClose }) => {
  const { user } = useSelector(Selectors.selectAuthData);
  const { data, loading } = useTimezones();
  const dispatch = useDispatch();

  const handleUpdateProfile = (data) =>
    dispatch(
      Async.updateProfile({
        data,
        onSuccess: () => {
          Toast(
            i18n.t('success-messages.successfully-toast.updated-profile'),
            'success'
          );
          onClose();
        },
        onError: (e) =>
          defaultErrorToast(
            i18n.t('errors.error-sorry-an-error-occurred-during.update-profile')
          )(e),
      })
    );

  return (
    <>
      <ModalHeader
        title={i18n.t('modules.timezone-modal.title')}
        noHasSubmitButton
      />
      <Formik
        initialValues={{
          timezone: user?.timezone,
        }}
        validationSchema={TimezoneSchema}
        onSubmit={handleUpdateProfile}
      >
        {({ values, handleChange, handleSubmit }) => (
          <S.Form onSubmit={handleSubmit} noValidate>
            <S.FormBody>
              <Row>
                <Col xs={12}>
                  <FormGroup>
                    <SelectTimezone
                      borders
                      id="timezone_search_id"
                      loading={loading}
                      searchPlaceholder={i18n.t(
                        'modules.timezone-modal.placeholders.search'
                      )}
                      options={data}
                      value={[values.timezone]}
                      onChangeSelect={(id) =>
                        handleChange({
                          target: {
                            name: 'timezone',
                            value: id,
                          },
                        })
                      }
                    />
                  </FormGroup>
                </Col>

                <Col xs={12}>
                  <S.FooterButtons>
                    <Button
                      medium
                      onClick={handleSubmit}
                      hasLoading={loading}
                      loading={loading}
                    >
                      {i18n.t('commons.buttons.save-button')}
                    </Button>
                  </S.FooterButtons>
                </Col>
              </Row>
            </S.FormBody>
          </S.Form>
        )}
      </Formik>
    </>
  );
};

UserWithoutTimezoneForm.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export const UserWithoutTimezoneModal = () => {
  const [isOpen, setIsOpen] = useState(true);
  return (
    <Modal isOpen={isOpen} setIsOpen={setIsOpen} width="500px">
      <UserWithoutTimezoneForm onClose={() => setIsOpen(false)} />
    </Modal>
  );
};
